

import React, { memo } from 'react';

import cx from 'classnames';
import { Button } from '../../../ui-kit';
import '../styles/_navigation-footer.scss';

const Position = Object.freeze({
  Start: 'start',
  Center: 'center',
  End: 'end'
});





















function NavigationFooter({
  children,
  onClickPrimary,
  primaryButtonText,
  primaryButtonBusy,
  primaryButtonDisabled,
  primaryButtonProps = {},
  onClickSecondary,
  secondaryButtonText,
  secondaryButtonBusy,
  secondaryButtonDisabled,
  secondaryButtonProps = {},
  childrenZeroWidth = true,
  customControl,
  customControlPosition = Position.End,
  progressBarAmount = 0
}) {
  return (
    <div className="navigation-footer">
      {progressBarAmount > 0 &&
      <div className="navigation-footer__progress__wrapper">
          <div className="navigation-footer__progress__container">
            <div
            className="navigation-footer__progress__bar"
            style={{ width: `${progressBarAmount}%` }} />

          </div>
        </div>}

      <div className={
      cx('navigation-footer__children', { 'navigation-footer__children_zero-width': childrenZeroWidth })}>


        {children}
      </div>
      <div className="navigation-footer__controls">
        {customControlPosition === Position.Start && customControl}
        {
        onClickSecondary ?

        <Button
          {...secondaryButtonProps}
          onClick={onClickSecondary}
          type="TERTIARY"
          busy={secondaryButtonBusy}
          disabled={secondaryButtonDisabled}>

                {secondaryButtonText}
              </Button> :

        null}

        {customControlPosition === Position.Center && customControl}
        {
        onClickPrimary ?

        <Button
          {...primaryButtonProps}
          onClick={onClickPrimary}
          busy={primaryButtonBusy}
          disabled={primaryButtonDisabled}>

                {primaryButtonText}
              </Button> :

        null}

        {
        customControlPosition !== Position.Start &&
        customControlPosition !== Position.Center &&
        customControl}

      </div>
    </div>);

}

NavigationFooter.defaultProps = {
  primaryButtonText: 'Continue',
  secondaryButtonText: 'Back'
};

export default memo(NavigationFooter);